import {Component, ElementRef, OnInit, Renderer2, ViewChild} from '@angular/core';
import {Platform, PopoverController} from '@ionic/angular';
import {SmallSelectItem} from '../../../../services/common-datatypes';
import {AdjustPopover} from '../../../../decorators/adjust-popover.decorator';

@Component({
    selector: 'app-simple-select-popover',
    templateUrl: './simple-select-popover.component.html',
    styleUrls: ['./simple-select-popover.component.scss']
})
@AdjustPopover('elementRef', 'itemListElem')
export class SimpleSelectPopoverComponent implements OnInit {
    @ViewChild('itemList', {read: ElementRef}) itemListElem!: ElementRef;
    public selectList: SmallSelectItem[] = [];
    public multiple = false;
    public selectedItems: SmallSelectItem[] = [];

    // Note: renderer, platform and elementRef is needed by @AdjustPopover
    constructor(private renderer: Renderer2,
                private elementRef: ElementRef,
                private platform: Platform,
                private popoverCtrl: PopoverController) {
    }

    ngOnInit() {
        this.selectList.forEach((item: SmallSelectItem) => {
            item.selected = false;
            for (let i = 0; i < this.selectedItems.length; i++) {
                if (this.selectedItems[i].isSame(item)) {
                    item.selected = true;
                    break;
                }
            }
        });
    }

    public selectItem(item: SmallSelectItem) {
        if (true === item.selected) { // deselect
            item.selected = false;
            for (let i = 0; i < this.selectedItems.length; i++) {
                if (this.selectedItems[i].isSame(item)) {  // deselect
                    this.selectedItems.splice(i, 1);
                    break;
                }
            }
        } else {    // add new
            item.selected = true;
            const newItem = new SmallSelectItem();
            newItem.updateFromJson(item);
            if (!this.multiple) {
                this.selectedItems.length = 0;
                this.selectedItems.push(newItem);
                this.close();
            } else {
                this.selectedItems.push(newItem);
            }
        }
    }

    public removeSelection() {
        this.selectList.forEach((item: SmallSelectItem) => {
            item.selected = false;
        });
        this.selectedItems.length = 0;
        this.close();
    }

    public submit() {
        this.close();
    }

    async close() {
        await this.popoverCtrl.dismiss(this.selectedItems);
    }
}
